import { ModalConfig } from "@/components/root/modal";
import { pxToRem } from "@/common/dom.functions";

/**
 * Shared config for every Gen AI expand modal.
 *
 * `Modal.vue` measures itself on mount and clamps to `innerWidth * 0.9` when the
 * requested width overflows the viewport — and because the wrapper carries
 * `transition-all duration-200`, that correction is visible as a wide→narrow
 * jump. Clamping up-front (the same way EventsModal already clamps its height)
 * means the requested size always fits, so the correction never fires.
 */
export const gen_ai_modal_config = (
  max_width_rem: number,
  max_height_rem: number
): ModalConfig => ({
  title: "",
  desc: "",
  blank: true,
  backdropDismiss: true,
  withTopRightCloseBtn: true,
  width: Math.min(max_width_rem, pxToRem(innerWidth) * 0.9) + "rem",
  height: Math.min(max_height_rem, pxToRem(innerHeight) * 0.9) + "rem",
});
